// ============================================================
//  GOVIND DEVELOPER — SITE CONFIG (EDIT THIS FILE)
//  All content lives here so the site is easy to update.
// ============================================================

export const SITE = {
  name: "Govind Developer",
  role: "AI Website Developer",
  headlineLines: ["I Build", "Websites That", "Grow Businesses."],
  highlightIndex: 2, // line shown with glowing gradient ("Grow Businesses.")
  description:
    "I create modern, responsive and conversion-focused websites using AI — from concept to live website.",
  phone: "8434586868",
  phoneHref: "tel:8434586868",
  email: "govindofficial027@gmail.com",
  location: "Bihar, Sitamarhi, Nanpur, Pupri, Safari Bahurar",
  // ↓ Drop your photo here (e.g. "/profile.jpg" placed in frontend/public/)
  //   Leave "" to show the premium "GD" monogram card.
  profileImage: "",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Demo Websites", href: "#demos" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const HERO_BADGES = [
  "AI Website Developer",
  "Modern Web Design",
  "Fast & Responsive",
];

export const MARQUEE_ITEMS = [
  "AI-Powered Development",
  "Modern Premium Design",
  "Fast & Responsive",
  "SEO Friendly Structure",
  "Conversion Focused",
  "Published & Delivered Online",
];

export const ABOUT_CHIPS = [
  "Businesses",
  "Coaching Institutes",
  "Gyms",
  "Colleges",
  "Mobile Shops",
  "Portfolios",
  "Landing Pages",
  "Custom AI Websites",
];

export const SERVICES = [
  {
    title: "Business Websites",
    desc: "Professional websites that build trust and turn visitors into customers.",
  },
  {
    title: "Coaching Institute Websites",
    desc: "Admission-focused websites for coaching centres with courses and enquiry forms.",
  },
  {
    title: "Gym & Fitness Websites",
    desc: "Bold, energetic websites designed for gyms, trainers and fitness brands.",
  },
  {
    title: "Mobile Shop Websites",
    desc: "Sleek product showcase websites for mobile and electronics shops.",
  },
  {
    title: "College / Education Websites",
    desc: "Structured, informative websites for colleges and educational institutions.",
  },
  {
    title: "Portfolio Websites",
    desc: "Personal portfolio websites that present your work with premium style.",
  },
  {
    title: "Landing Pages",
    desc: "High-converting single pages built to capture leads and sell fast.",
  },
  {
    title: "Custom AI-Powered Websites",
    desc: "Unique websites built with AI — tailored exactly to your business idea.",
  },
];

// ============================================================
//  DEMO WEBSITES — replace each "url" with your live demo link.
//  The in-site preview modal and "Open Live Site" button use it.
// ============================================================
export const DEMOS = [
  {
    title: "Gym Website",
    desc: "Modern fitness website designed for gyms, trainers and fitness businesses.",
    url: "https://your-demo-url.com/gym-website",
    variant: "tiles",
  },
  {
    title: "Coaching Website",
    desc: "Clean coaching institute website built to attract admissions and enquiries.",
    url: "https://your-demo-url.com/coaching-website",
    variant: "rows",
  },
  {
    title: "Mobile Shop Website",
    desc: "Sleek mobile shop website with product showcase and offer highlights.",
    url: "https://your-demo-url.com/mobile-shop-website",
    variant: "tiles",
  },
  {
    title: "College Website",
    desc: "Structured education website with courses, notices and admission details.",
    url: "https://your-demo-url.com/college-website",
    variant: "rows",
  },
  {
    title: "Business Website",
    desc: "Professional business website designed to build trust and win clients.",
    url: "https://your-demo-url.com/business-website",
    variant: "rows",
  },
  {
    title: "Restaurant Website",
    desc: "Appetising restaurant website with menu showcase and table enquiries.",
    url: "https://your-demo-url.com/restaurant-website",
    variant: "tiles",
  },
  {
    title: "E-commerce Website",
    desc: "Online store layout with product grid, offers and smooth checkout flow.",
    url: "https://your-demo-url.com/ecommerce-website",
    variant: "tiles",
  },
  {
    title: "Portfolio Website",
    desc: "Premium personal portfolio website that presents work with cinematic style.",
    url: "https://your-demo-url.com/portfolio-website",
    variant: "rows",
  },
];

// EDITABLE PLACEHOLDER STATS — update values anytime, they re-animate automatically.
export const STATS = [
  { value: 25, suffix: "+", label: "AI Websites" },
  { value: 30, suffix: "+", label: "Modern Designs" },
  { value: 100, suffix: "%", label: "Responsive Websites" },
  { value: 15, suffix: "+", label: "Client Projects" },
];

export const WHY_ME = [
  {
    title: "AI-Powered Development",
    desc: "Websites built faster and smarter using cutting-edge AI tools.",
  },
  {
    title: "Modern Premium Design",
    desc: "Clean, premium layouts that make your business look world-class.",
  },
  {
    title: "Mobile Responsive",
    desc: "A perfect experience on Android, iPhone, tablet and desktop.",
  },
  {
    title: "Fast Performance",
    desc: "Optimised, quick-loading pages that keep visitors engaged.",
  },
  {
    title: "SEO Friendly Structure",
    desc: "Built so Google can find and rank your business online.",
  },
  {
    title: "Client-Focused Approach",
    desc: "From first call to final delivery, your goals lead the project.",
  },
];

export const PROCESS = [
  {
    num: "01",
    title: "Discuss",
    desc: "We talk about your business, your goals and exactly what your website needs to achieve.",
  },
  {
    num: "02",
    title: "Design",
    desc: "I plan a clean, modern layout and structure that fits your brand and converts visitors.",
  },
  {
    num: "03",
    title: "Build with AI",
    desc: "Using AI-powered tools and modern web technology, I build your website fast — without cutting quality.",
  },
  {
    num: "04",
    title: "Publish & Deliver",
    desc: "Your website goes live on the internet, fully connected and ready to bring you customers.",
  },
];
